import script from "./AdviceDetailsActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdviceDetailsActions.vue?vue&type=script&setup=true&lang=ts"

import "./AdviceDetailsActions.vue?vue&type=style&index=0&id=639653cd&lang=sass"

const __exports__ = script;

export default __exports__